import React, { ButtonHTMLAttributes } from 'react';
import styles from './cardHeaderButton.module.scss';

const PageCardButton = ({ children, className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button 
      className={`btn btn-sm ${styles.pageCardBtn}${className ? ` ${className}` : ""}`}
      {...props}
    >
      {children}
    </button>
  )
}

export default PageCardButton;